'use client';

import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, TextField } from '@mui/material';
import { inputSx } from './fieldStyles';

// A 6-digit one-time-code input, shared by the MFA verify and MFA setup steps.
export const VerificationCodeField = t0 => {
  const $ = _c(13);
  const {
    id,
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = <FormLabel htmlFor={id}>Verification code</FormLabel>;
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onChange) {
    t2 = e => onChange(e.target.value.trim());
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== id) {
    t3 = {
      htmlInput: {
        id,
        "data-testid": id,
        inputMode: "numeric",
        autoComplete: "one-time-code",
        maxLength: 6
      }
    };
    $[4] = id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== value) {
    t4 = <TextField autoFocus={true} value={value} onChange={t2} sx={inputSx} slotProps={t3} />;
    $[6] = t2;
    $[7] = t3;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <FormControl size="small" className="w-full">{t1}{t4}</FormControl>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};